export const translate = (key: string) => Mashie.Resources.GetString(key);